/*

	 * Main JS file
	We eliminated jQuery dependency for better performance and modern practices.

	To use Ajax with vanilla JS, you can use the Fetch API or Axios. (Axios is too heavy)
	https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API

	Docs for using vanilla js instead jquery:
	https://youmightnotneedjquery.com



*/


import { MainSmooth } from './src/main-smooth';

const app = new MainSmooth({
	is_ajax: true,
	debug: document.location.hostname !== 'fondationtrahan.org',
	slide_transition: false,
	time_fade_in: 1.4, //0.17,
	time_fade_out: 0.8, //0.1,
	project_name: "Fondation Trahan",
	$scroll_el: '#smooth-scroll',
	is_lenis: true,

	//GA_MEASUREMENT_ID 	: 'G-9TYL5NPZ8Y',

	redirects: [
		//['/work/', '/work/filter/featured/'],
		//['/about/', '/about/profile/']
	]

});

app.init();

